import sendLocalRequest from "./sendLocalRequest";

export const getMachinesReport = (auth_token) => {
    return  new Promise( (resolve, reject) => {
        sendLocalRequest(`machines/report`, "GET", auth_token).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });

};
